import React, { useEffect, useState } from "react";
import "./adultchildroomselector.css";

export default function AdultChildRoomSelector({
  bookingInfo,
  roomName,
  maxAdults,
  maxChildren,
  onChange,
}) {
  const [adults, setAdults] = useState(0);
  const [children, setChildren] = useState(0);

  const handleAdultsChange = (e) => {
    const newAdults = Number(e.target.value);
    console.log('newAdults::: ', newAdults);
    const extraAdultCount = newAdults > 2 ? newAdults - 2 : 0;
    setAdults(newAdults);
    onChange({ adults: newAdults, children, extraAdultCount, extraChildCount: children });
  };

  const handleChildrenChange = (e) => {
    const newChildren = Number(e.target.value);
    const extraChildCount = newChildren > 1 ? newChildren - 1 : 0;
    setChildren(newChildren);
    onChange({ adults, children: newChildren, extraAdultCount: adults > 2 ? adults - 2 : 0, extraChildCount });
  };

  useEffect(() => {
    // console.log('bookingInfo: ', bookingInfo);
    // console.log('maxChildren: ', maxChildren);
    // console.log('maxAdults: ', maxAdults);
    // console.log('roomName: ', roomName);
  },[roomName, maxAdults, maxChildren,bookingInfo])

  useEffect(() => {
      setAdults(bookingInfo?.property?.base_adult_occupancy)
      setChildren(bookingInfo?.property?.base_child_occupancy)
  },[])

  return (
    <div className="room_selector_container">
      <span className="room-name">{roomName}</span>
      <div className="controls">
        <div className="control-group">
          <label className="control-label">Adults</label>
          <select value={adults} onChange={handleAdultsChange}>
            {[...Array(maxAdults).keys()].map((num) => (
              <option key={num} value={num + 1}>
                {num + 1}
              </option>
            ))}
          </select>
        </div>
        <div className="control-group">
          <label className="control-label">Children</label>
          <select value={children} onChange={handleChildrenChange}>
            {[...Array(maxChildren + 1)?.keys()]?.map((num) => (
              <option key={num} value={num}>
                {num}
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
}
